import Container from '@/components/@base/container';

const DesktopPageLoader = () => {
  return (
    // اضافه کردن dark:bg برای کل صفحه
    <Container className='fixed h-fit inset-0 z-[1000] mx-auto mt-10 bg-white p-4 lg:mx-10 lg:max-w-[1300px] xl:mx-auto dark:bg-grayLight-990'>
      {/* Header Skeleton */}
      {/* هماهنگی با border-grayDark-900 در حالت دارک */}
      <Container className='mb-8 flex justify-between border-b border-grayLight-40 pb-4 dark:border-grayDark-900'>
        <Container className='relative h-6 w-24 overflow-hidden rounded-md bg-grayLight-40 dark:bg-grayDark-900'>
          <Container className='loading-asset' />
        </Container>
        <Container className='relative h-6 w-24 overflow-hidden rounded-md bg-grayLight-40 dark:bg-grayDark-900'>
          <Container className='loading-asset' />
        </Container>
      </Container>

      {/* Main Grid (2 Columns) */}
      <Container className='grid grid-cols-12 gap-10'>
        {/* Left Side */}
        <Container className='col-span-7 flex flex-col gap-4'>
          {[1, 2, 3].map((i) => (
            // اضافه کردن دارک مود به border
            <Container
              key={i}
              className='flex items-center gap-4 rounded-lg border border-grayLight-40 p-4 dark:border-grayDark-900'
            >
              <Container className='relative h-10 w-10 overflow-hidden rounded-md bg-grayLight-40 dark:bg-grayDark-900'>
                <Container className='loading-asset' />
              </Container>
              <Container className='relative h-4 w-48 overflow-hidden rounded-md bg-grayLight-40 dark:bg-grayDark-900'>
                <Container className='loading-asset' />
              </Container>
            </Container>
          ))}
          <Container className='relative mt-8 h-8 w-32 overflow-hidden rounded-md bg-grayLight-40 dark:bg-grayDark-900'>
            <Container className='loading-asset' />
          </Container>
          <Container className='relative mt-4 h-24 w-full overflow-hidden rounded-lg bg-grayLight-40 dark:bg-grayDark-900'>
            <Container className='loading-asset' />
          </Container>
        </Container>

        {/* Right Side */}
        <Container className='col-span-5 flex flex-col gap-6'>
          <Container className='relative h-32 w-full overflow-hidden rounded-xl bg-grayLight-40 dark:bg-grayDark-900'>
            <Container className='loading-asset' />
          </Container>
          <Container className='relative h-64 w-full overflow-hidden rounded-xl bg-grayLight-40 dark:bg-grayDark-900'>
            <Container className='loading-asset' />
          </Container>
        </Container>
      </Container>
    </Container>
  );
};

export default DesktopPageLoader;
